import { Component, ViewEncapsulation, OnInit, ViewChild } from '@angular/core';
import { SelfAttendanceService } from "../../../shared/services/self-attendance.service";
import { ActivatedRoute, Router } from "@angular/router";
import { PaymentMethodOption } from "../../../shared/model/payment-method-option";
import { SelfAttendanceData } from "../../../shared/model/self-attendance-data";
import { SYDLEClientID } from "../../../shared/constants/one-constants";
import { SessionStorageService } from "../../../shared/services/session-storage.service";
import { DtmService } from "../../../services/dtm.service";
import { environment } from "../../../../environments/environment";
import { PaymentFormComponent } from "../../../shared/components/payment-form/payment-form.component";
import {
  automaticRechargePaymentChangeDataError,
  braspagReasonCode, errorMapping, adyenReasonCode
} from "../../../shared/constants/errors";
import { DialogLoadingComponent } from "../../../shared/components/dialog-loading/dialog-loading.component";
import { LoadingComponent } from 'src/app/shared/components/loading/loading.component';
import { MatDialog } from "@angular/material/dialog";
import { Product } from "../../../shared/model/product";
import { Dtm, getDtm } from "../../../shared/enum/dtm";
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service';
import { CreditCardData } from 'src/app/shared/model/credit-card-data';

@Component({
    selector: 'pme-self-attendance-auto-recharge-payment-change',
    templateUrl: './auto-recharge-payment-change.component.html',
    styleUrls: ['./auto-recharge-payment-change.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class SelfAttendanceAutoRechargePaymentChangeComponent implements OnInit {

  @ViewChild(PaymentFormComponent) paymentForm: PaymentFormComponent;
  @ViewChild(PaymentFormComponent) paymentAdyenForm: PaymentFormComponent;

  // Hero Inicial
  heroData: any;


  classificationIdentifier: string;

  currentPaymentMethod: string;
  showForm: boolean;

  selfAttendanceData: SelfAttendanceData;
  currentPackage: Product;
  productValue: string;

  paymentOptions: Array<PaymentMethodOption>;
  buttonName: string = 'Alterar forma de pagamento';
  redirectUrl: string = environment.serasaHomePage;
  context: string;

  paymentErrors: Array<string> = [];

  // SessionStorage Variables ( REMOVER DEFAULT )
  hashString: string;
  userId: string;
  businessId: string;

  showErrorHero: boolean = false;

  creditCardsData: CreditCardData[];
  maxLimitCreditCards: boolean;
  creditCardData: CreditCardData;

  tdu: string;
  shopWindowLink: string;

  constructor(
    private selfAttendanceService: SelfAttendanceService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    public dtmService: DtmService,
    public sessionStorageService: SessionStorageService,

  ) {
    if (!this.sessionStorageService.isReloading()) {
      localStorage.removeItem('selfAttendanceData');
      this.sessionStorageService.resetSessionStorage();
    }

    sessionStorage.setItem('shopWindowRoute', 'recarga')
    this.classificationIdentifier = this.sessionStorageService.getClassification(route);

    this.sessionStorageService.clearSessionStorage(
      ['category', 'product', 'identificacaoCompleted', 'pagamentoCompleted', 'sucessoCompleted']);


    this.dtmService.pageLoaded(Dtm.AlteracaoDePagamentoRecarga, true, getDtm(Dtm.AlteracaoDePagamentoRecarga, this.classificationIdentifier));
    this.dtmService.sendPageLoadEvent();

    // Gets the UserID and BusinessId from SessionStorage
    this.getProvisioningParametersFromSessionStorage();

    this.route.queryParams.subscribe((params) => {
      if (params.userId && params.businessId) {
        this.userId = params.userId;
        this.businessId = params.businessId;
        this.setProvisioningParametersOnSessionStorage();
      }

      this.hashString = params.hash;

      if (params.redirectUrl) {
        this.redirectUrl = params.redirectUrl;

        this.selfAttendanceService.redirectURL = this.redirectUrl;
        sessionStorage.setItem('redirectURL', this.redirectUrl);
        sessionStorage.setItem('selfAttendance', 'true');
      }
    });

    this.shopWindowLink = window.location.origin + '/auto-atendimento/consulta-e-recuperacao-de-dividas/alterar-recarga-garantida?userId=' + this.userId + '&businessId=' + this.businessId;

    selfAttendanceService.getStoredCreditCards(this.userId, this.businessId, this.hashString).subscribe(results => {
      this.creditCardsData = results[0].length ? results[0] : null;
      this.maxLimitCreditCards = results[1];
    }
    );

    selfAttendanceService.getStoredCreditCard(this.userId, this.businessId)
      .subscribe(r => {
        this.creditCardData = r;
      });
  }

  openDialogSpinner(): void {
    this.closeDialogSpinner();
    this.dialog.open(LoadingComponent, {
      disableClose: true,
      width: "400px",
      panelClass: "pme-dialog-loading-panel",
      backdropClass: 'pme-dialog-loading-backdrop'
    });
  }

  closeDialogSpinner(): void {
    this.dialog.closeAll();
  }

  ngOnInit() {
    this.openDialogSpinner();
    this.dtmService.customLoaded(["AddToCart", "Checkout"], 'Sydle-alterar-pagamento');

    this.selfAttendanceService.getAutomaticRechargePaymentChangeData(this.businessId, this.userId, this.hashString).subscribe(
      (selfAttendanceData) => {
        this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);
        this.selfAttendanceData = selfAttendanceData;

        let automaticRechargeValue = this.selfAttendanceData.automaticRecharge;
        let automaticRecharge = Number.isNaN(Number(automaticRechargeValue)) ? automaticRechargeValue : Number(automaticRechargeValue).toFixed(2).replace('.', ',');


        this.tdu = selfAttendanceData.tdu;

        this.heroData = {
          type: 'money-info',
          title: 'Ativar recarga garantida',
          contents: ['Quando seu crédito for igual ou menor que R$ ' + automaticRecharge + ', será feita uma nova recarga no valor do pacote escolhido sem desconto aplicado.']
        };

        sessionStorage.setItem('name', this.selfAttendanceData.account.name);
        sessionStorage.setItem('email', this.selfAttendanceData.account.email);

        this.currentPackage = this.selfAttendanceData.account.wallet.automaticRecharge.product;
        this.productValue = this.selfAttendanceData.account.wallet.productValue;
        this.paymentOptions = this.selfAttendanceData.paymentOptions;

        this.currentPaymentMethod = this.paymentOptions[0].identifier;
        this.userId = this.selfAttendanceData.account.userId;
        this.businessId = this.selfAttendanceData.account.businessId;

        this.dtmService.productsLoaded(
          [{
            'classificationName': this.currentPackage.classificationName,
            'identifier': this.currentPackage.identifier
          }]
        );
        this.closeDialogSpinner();
        this.showForm = true;
      },
      (error) => {
        this.showCustomError('automaticRechargePaymentChangeDataError', error);
      },
      () => {
        this.dtmService.sendPageLoadEvent();
      }
    )
  }

  onSubmit(paymentData: any) {
    this.dtmService.customClickEvent(this.buttonName);

    let requestData: any = {};
    requestData.paymentMethodIdentifier = paymentData.identifier;

    requestData.businessId = this.businessId;
    requestData.userId = this.userId;
    requestData.productId = this.currentPackage._id;
    requestData.action = 'PAYMENT_CHANGE';

    requestData.defaultCard = paymentData.defaultCard;
    requestData.saveCard = paymentData.saveCard;
    requestData.nickname = paymentData.nickname;
    requestData.accountPaymentDataId = paymentData.accountPaymentDataId;

    if (paymentData.isAdyen) {
      requestData.encryptedCardNumber = paymentData.card.encryptedCardNumber;
      requestData.encryptedCardSecurityCode = paymentData.card.encryptedCardSecurityCode;
      requestData.encryptedCardValidityMonth = paymentData.card.encryptedCardValidityMonth;
      requestData.encryptedCardValidityYear = paymentData.card.encryptedCardValidityYear;
      requestData.cardNumber = paymentData.card.cardNumber;
      requestData.isAdyen = true;
    } else {
      requestData.cardNumber = this.maskCreditCardNumber(paymentData.card.cardNumber);
      requestData.expirationMonth = this.getExpirationMonth(paymentData.card.cardValidityDate);
      requestData.expirationYear = this.getExpirationYear(paymentData.card.cardValidityDate);
      requestData.paymentToken = "";
    }

    requestData.cardHolder = paymentData.card.cardHolder;
    requestData.cardBrand = paymentData.card.brand;

    requestData.paymentConditionIdentifier = paymentData.paymentConditionIdentifier;
    this.selfAttendanceService.activateAutomaticRecharge(requestData).subscribe(
      (selfAttendanceData) => {
        this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);
        this.selfAttendanceService.redirectURL = this.redirectUrl;

        if (selfAttendanceData.errorRFB) {
          this.paymentForm.addValidationError(errorMapping['mitigationMessageError']);
          // Analytics
          this.dtmService.customErrorLoaded(["error"], {
            errorDetail: '',
            errorMessage: errorMapping['mitigationMessageError'],
          });
          if (this.paymentForm) {
            this.paymentForm.submitting = false;
            this.paymentForm.disableSubmit = true;
          }
        } else {
          this.router.navigate(['../../sucesso'], { relativeTo: this.route });
        }
      }, (error) => {
        this.showCustomError('paymentChangeError', error);
      }
    );
  }

  showCustomError(customErrorKey: string, integrationError?: any) {
    let integrationErrorMessage: any;

    switch (customErrorKey) {
      case 'automaticRechargePaymentChangeDataError':
        integrationErrorMessage = this.showCustomHeroError(integrationError, 'automaticRechargePaymentChangeDataError');

        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        break;
      case 'paymentChangeError':
        integrationErrorMessage = this.handlePaymentChange(integrationError);

        console.error(integrationErrorMessage);

        this.paymentForm.addValidationError(integrationErrorMessage.userMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        break;
      default:
        break;
    }
    if (this.paymentForm) {
      this.paymentForm.submitting = false;
      this.paymentForm.enableFields('all');
    }
  }

  maskCreditCardNumber(cardNumber: string): string {
    const unmaskedValue = cardNumber.substr(cardNumber.length - 4, 4);
    let maskedValue = cardNumber.substr(0, cardNumber.length - 4);
    maskedValue = maskedValue.split(' ').map(
      digitGroup => {
        let maskedGroup = '';
        while (maskedGroup.length < digitGroup.length) {
          maskedGroup += '*';
        }
        return maskedGroup;
      }
    ).join(' ');
    return maskedValue + unmaskedValue;
  }

  getExpirationMonth(expirationDate) {
    if (expirationDate) {
      let expirationMonth = expirationDate.split("/")[0];
      if (expirationMonth.length === 1) {
        return '0' + expirationMonth;
      } else {
        return expirationMonth;
      }
    } else {
      return '';
    }
  }

  getExpirationYear(expirationDate) {
    if (expirationDate) {
      let expirationYear = expirationDate.split("/")[1];
      return "20" + expirationYear;
    } else {
      return '';
    }
  }

  getProvisioningParametersFromSessionStorage() {
    this.userId = this.sessionStorageService.getUserId();
    this.businessId = this.sessionStorageService.getBusinessId();

    this.dtmService.userLoaded({
      'userId': this.userId,
      'businessId': this.businessId,
      'clientId': SYDLEClientID
    });

    if (!this.userId || !this.businessId) {
      this.sessionStorageService.setIsLogged(false);
    } else {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  setProvisioningParametersOnSessionStorage() {
    this.sessionStorageService.setUserIdAndBusinessId(this.userId, this.businessId);
    this.dtmService.userLoaded({
      userId: this.userId,
      businessId: this.businessId,
      clientId: SYDLEClientID,
    });

    if (this.userId && this.businessId) {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  handlePaymentChange(error: any): any {
    let resultError: any = {};

    try {
      if (typeof error === "string") {
        error = JSON.parse(error);
      }

      if (error.status && error.error) {
        resultError.status = error.status;
        resultError.endpoint = error.url;
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === "ERROR";
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === "WARNING";
        });

        resultError.userMessage = error.error._messages[0].text;

        // Nova errorString
        resultError.errorString = (resultError.context || "SYDLE") + ":CODE:" + error.status + ":HTTP:" + (resultError.errorCode || resultError.status) + ":POST/" + resultError.endpoint + ":" + JSON.stringify(resultError.errors.map(({ text }) => text));

        //resultError.errorString = `${resultError.status}:${resultError.name}:${resultError.endpoint}:${JSON.stringify(resultError.errors)}:${JSON.stringify(resultError.warnings)}`;

        if (braspagReasonCode[resultError.userMessage]) {
          resultError.userMessage = braspagReasonCode[resultError.userMessage];
        } else if (adyenReasonCode[resultError.userMessage]) {
          resultError.userMessage = adyenReasonCode[resultError.userMessage];
        } else if (resultError.userMessage.indexOf('java') >= 0 ||
          resultError.userMessage.indexOf('Java') >= 0 ||
          resultError.userMessage.indexOf("Script") >= 0 ||
          resultError.userMessage.indexOf("script") >= 0 ||
          resultError.userMessage.indexOf('elastic') >= 0 ||
          resultError.userMessage.indexOf('Elastic') >= 0) {
          resultError.userMessage = "Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.";
        }
      }
    } catch (e) {
    }

    return resultError;
  }

  showCustomHeroError(error, type) {
    let resultError: any = {};

    try {
      if (typeof error === "string") {
        error = JSON.parse(error);
      }

      if (error.status && error.error) {
        resultError.status = error.status;
        resultError.endpoint = error.url;
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === "ERROR";
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === "WARNING";
        });

        // Nova errorString
        resultError.errorString = (resultError.context || "SYDLE") + ":CODE:" + error.status + ":HTTP:" + (resultError.errorCode || resultError.status) + ":POST/" + resultError.endpoint + ":" + JSON.stringify(resultError.errors.map(({ text }) => text));

        //resultError.errorString = `${resultError.status}:${resultError.name}:${resultError.endpoint}:${JSON.stringify(resultError.errors)}:${JSON.stringify(resultError.warnings)}`;

        resultError.userMessage = error.error._messages[0].text;
        resultError.code = error.error._messages[0].code;

        switch (type) {
          case 'automaticRechargePaymentChangeDataError':
            if (automaticRechargePaymentChangeDataError[resultError.code]) {
              this.heroData = {
                'type': 'error',
                'title': automaticRechargePaymentChangeDataError[resultError.code].title,
                'contents': automaticRechargePaymentChangeDataError[resultError.code].contents
              }
            } else {
              this.heroData = {
                'type': 'error',
                'title': 'Serviço indisponível!',
                'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
              }
            }
            break;
          default:
            this.heroData = {
              'type': 'error',
              'title': 'Serviço indisponível!',
              'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
            }
            break;
        }
      }
    } catch (e) {
      console.error(e);
      resultError.errorString = JSON.stringify(error);
      this.heroData = {
        'type': 'error',
        'title': 'Serviço indisponível!',
        'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
      }
    }

    this.closeDialogSpinner();
    this.heroData.showButton = true;
    this.heroData.buttonName = 'Voltar';
    this.heroData.redirectURL = this.redirectUrl;
    this.showErrorHero = true;
    return resultError;
  }

  returnPage() {
    window.location.href = this.redirectUrl;
  }

  handleDeleteCreditCard(accountPaymentDataId: string): void {
    this.selfAttendanceService.removeCreditCard(this.userId, this.businessId, accountPaymentDataId)
      .subscribe(results => {
        this.creditCardsData = results[0].length ? results[0] : null;
        this.maxLimitCreditCards = results[1];
      });
  }

  // triggerPurchaseOnAutomaticRecharge(selfAttendanceData: SelfAttendanceData) {
  //   this.dtmService.checkoutSuccess({
  //     orderId: selfAttendanceData.contract.code,
  //     pagamento: selfAttendanceData.contract.paymentMethod.identifier,
  //     orderEventId: this.checkoutSuccessData.creditCardData ? selfAttendanceData.creditCardData.invoiceId : selfAttendanceData.bankBilletData ? selfAttendanceData.bankBilletData.invoiceId : '',
  //     totalPrice: this.totalValue,
  //     amountPaid: this.totalValue,
  //     firstTime: selfAttendanceData.contract.adobeAnalyticsData ? selfAttendanceData.contract.adobeAnalyticsData.firstPurchase : null,
  //     orderType: selfAttendanceData.contract.adobeAnalyticsData ? selfAttendanceData.contract.adobeAnalyticsData.purchaseType : null,
  //     amountRemaining: selfAttendanceData.contract.product.value ? selfAttendanceData.contract.product.value - this.totalValue : 0,
  //     amountTotal: selfAttendanceData.contract.product.value,
  //     coupon: selfAttendanceData.getConcatenatedDiscounts(),
  //     couponAmount: this.couponAmount,
  //     autoRecharge: selfAttendanceData.contract.provisioningParameters.allowAutomaticRecharge,
  //     appliedCoupons: selfAttendanceData.contract.paymentMethod.identifier === 'BANK_BILLET' ?
  //       selfAttendanceData.bankBilletData.appliedCoupons : selfAttendanceData.creditCardData.appliedCoupons,
  //     installments: selfAttendanceData.contract.paymentMethod.identifier === 'CREDIT_CARD' ?
  //       selfAttendanceData.contract.paymentMethod.paymentConditionIdentifier : null,
  //     purchaseStatus: selfAttendanceData.contract.status
  //   });
  //
  //   this.dtmService.sendPageLoadEvent('Purchase');
  //
  // }
}

